import { render, staticRenderFns } from "./AdjustTransactionPayment.vue?vue&type=template&id=5d6b0c04&scoped=true"
import script from "./AdjustTransactionPayment.vue?vue&type=script&lang=js"
export * from "./AdjustTransactionPayment.vue?vue&type=script&lang=js"
import style0 from "./AdjustTransactionPayment.vue?vue&type=style&index=0&id=5d6b0c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b0c04",
  null
  
)

export default component.exports